module.exports = __webpack_public_path__ + "img/banner.8613a384.jpg";